import { Box, styled } from '@mui/material';

export const DottedDivider = styled(Box)(({ theme }) => ({
  height: theme.spacing(0.25),
  backgroundSize: theme.spacing(1),
  backgroundImage: `radial-gradient(circle closest-side, ${theme.palette.divider} 100%, transparent)`,
}));
